import React, { useEffect, useState } from 'react'
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader'
import { getUsuarios, updateCliente } from '../../../services/apis';
import { useNavigate } from 'react-router-dom';
import { Badge, Button, CircularProgress, Dialog, DialogContent, Divider, FormControlLabel, Grid, Switch, TextField, Typography } from '@mui/material';
import { UsuarioCard } from './UsuarioCard';
import { FormCrearUsuario } from './FormCrearUsuario';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { EditarUsuario } from './EditarUsuario';

import ApartmentIcon from '@mui/icons-material/Apartment';
import CancelIcon from '@mui/icons-material/Cancel';
import PersonIcon from '@mui/icons-material/Person';
import DevicesIcon from '@mui/icons-material/Devices';

export const Usuarios = () => {
	const navigate = useNavigate();

	//estados
	const [usuarios, setUsuarios] = useState([]);
	const [usuariosOG, setUsuariosOG] = useState([]);
	const [dispositivos, setDispositivos] = useState([]);
	const [dispositivosOG, setDispositivosOG] = useState([]);
	const [departamentos, setDepartamentos] = useState([]);
	const [roles, setRoles] = useState([]);
	const [clientes, setClientes] = useState([]);
	const [opciones, setOpciones] = useState([]);
	const [openCrearUsuario, setOpenCrearUsuario] = useState(false);
	// const [openCrearDispositivo, setOpenCrearDispositivo] = useState(false);

	/* ============================================
	   ESTADOS DE CLIENTES (COMENTADOS TEMPORALMENTE)
	   ============================================ */
	// const [usuariosClientes, setUsuariosClientes] = useState([]);
	// const [usuariosClientesAgrupados, setUsuariosClientesAgrupados] = useState([]);
	// const [usuariosClientesAgrupadosOG, setUsuariosClientesAgrupadosOG] = useState([]);

	const [opcionesUsuario, setOpcionesUsuario] = useState([]);

	const [loaded, setLoaded] = useState(false);
	const [open, setOpen] = useState(false);

	/* ============================================
	   ESTADO DE CLIENTE ABIERTO (COMENTADO TEMPORALMENTE)
	   ============================================ */
	// const [openCliente, setOpenCliente] = useState(null);

	/* ============================================
	   HANDLE CLOSE CLIENTE (COMENTADO TEMPORALMENTE)
	   ============================================ */
	// const handleClose = () => {
	// 	console.log(openCliente);
	// 	setOpenCliente(null);
	// };

	useEffect(() => {
		cargarUsuarios();
	}, [])

	const cargarUsuarios = async () => {
		try {
			const response = await getUsuarios();
			if (response.success === true) {
				console.log('Datos recibidos del backend:', response.data);

				// Los datos ya vienen separados del backend
				setUsuarios(response.data.usuarios);
				setUsuariosOG(response.data.usuarios);
				setDispositivos(response.data.dispositivos);
				setDispositivosOG(response.data.dispositivos);
				setRoles(response.data.roles);
				setDepartamentos(response.data.departamentos);
				setClientes(response.data.clientes);

				/* ============================================
				   DATOS DE CLIENTES (COMENTADOS TEMPORALMENTE)
				   ============================================ */
				// setUsuariosClientes(response.data.usuarios_clientes);
				// setUsuariosClientesAgrupados(response.data.usuarios_clientes_agrupados);
				// setUsuariosClientesAgrupadosOG(response.data.usuarios_clientes_agrupados);

				setOpciones(response.data.opciones);
				setOpcionesUsuario(response.data.opciones_usuario);
				setLoaded(true);
			} else {
				navigate('/');
			}

		} catch (error) {
			console.error("Error al cargar usuarios:", error);
			navigate('/');
		}
	}

	const handleEvent = (opcionId) => {
		opcionId = opcionId.toString(); // Asegurarse de que sea string para el switch

		switch (opcionId) {
			case "1":
				setOpenCrearUsuario(true);
				break;
			// case 2:
			// 	setOpenCrearDispositivo(true);
			// 	break;
			default:
				console.log("Lógica para una opción desconocida");
				break;
		}
	};

	/* ============================================
	   ACCESO TIENDA (COMENTADO TEMPORALMENTE)
	   ============================================ */
	// const accesoTienda = async (event, idCliente) => {
	// 	console.log(event.target.checked, idCliente);
	// 	let acceso = event.target.checked ? 1 : 0;

	// 	try {
	// 		const response = await updateCliente(idCliente, acceso);
	// 		console.log(response);

	// 		if (response.success) {
	// 			cargarUsuarios();
	// 		}

	// 	} catch (error) {
	// 		console.error("Error:", error);
	// 	}
	// }

	// Búsqueda de usuarios normales
	const buscarUsuario = (event) => {
		const searchTerm = event.target.value.toLowerCase();

		if (searchTerm === "") {
			setUsuarios(usuariosOG);
			return;
		}

		const resultados = usuariosOG.filter(usu => {
			return (
				usu.nombre.toLowerCase().includes(searchTerm) ||
				(usu.apellidos && usu.apellidos.toLowerCase().includes(searchTerm)) ||
				(usu.mail && usu.mail.toLowerCase().includes(searchTerm)) ||
				(usu.nombre_rol && usu.nombre_rol.toLowerCase().includes(searchTerm))
			);
		});

		setUsuarios(resultados);
	}

	// Búsqueda de dispositivos
	const buscarDispositivo = (event) => {
		const searchTerm = event.target.value.toLowerCase();

		if (searchTerm === "") {
			setDispositivos(dispositivosOG);
			return;
		}

		const resultados = dispositivosOG.filter(dispositivo => {
			return (
				dispositivo.nombre.toLowerCase().includes(searchTerm) ||
				(dispositivo.apellidos && dispositivo.apellidos.toLowerCase().includes(searchTerm)) ||
				(dispositivo.mail && dispositivo.mail.toLowerCase().includes(searchTerm))
			);
		});

		setDispositivos(resultados);
	}

	/* ============================================
	   BUSCAR EMPRESA (COMENTADO TEMPORALMENTE)
	   ============================================ */
	// const buscarEmpresa = (event) => {
	// 	console.log(event.target.value);
	// 	const searchTerm = event.target.value.toLowerCase();

	// 	if (searchTerm === "") {
	// 		setUsuariosClientesAgrupados(usuariosClientesAgrupadosOG);
	// 		return;
	// 	}

	// 	const resultados = usuariosClientesAgrupadosOG.filter(empresa => {
	// 		return (
	// 			empresa.nombre_cliente.toLowerCase().includes(searchTerm)
	// 		);
	// 	});

	// 	setUsuariosClientesAgrupados(resultados);
	// }

	return (
		<div className='menu-back fade-in2'>
			<SubHeader titulo={'Usuarios'} />
			{!loaded && (<CircularProgress />)}
			{loaded && (
				<>
					<Grid container direction={'column'} xs={12} >
						<OpcionesMenuFunc opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
					</Grid>

					<Grid container direction="row" padding="1em" justifyContent={'space-around'} alignItems={'start'} gap={4}>

						{/* ============================================
						   CONTENEDOR PRINCIPAL DE USUARIOS
						   ============================================ */}
						<Grid container xs={11} >
							<Grid
								container
								direction="column"
								justifyContent="start"
								alignItems="start"
								xs={11}
							>
								<Typography variant="h4" gutterBottom>
									<PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
									Usuarios: {usuarios.length > 0 ? usuarios.length : ''}
								</Typography>
							</Grid>

							<Grid item xs={12} sx={{ mb: 2 }}>
								<TextField
									id="buscar-usuario"
									label="Buscar usuario..."
									variant="standard"
									size="small"
									name='search'
									fullWidth
									onChange={buscarUsuario}
								/>
							</Grid>

							<Grid container
								direction="row"
								justifyContent="center"
								alignItems="center"
								xs={12}
								gap={2}
							>
								{usuarios.length > 0 ? (
									usuarios.map((usuario) => (
										<Grid item xs={12} sm={12} md={10} lg={5.5} xl={1.7} key={usuario.id}>
											<UsuarioCard
												usuario={usuario}
												opciones={opcionesUsuario}
												cargarUsuarios={cargarUsuarios}
												roles={roles}
												clientes={clientes}
												departamentos={departamentos}
												tipo="usuario"
											/>
										</Grid>
									))
								) : (
									<Grid item xs={12}>
										<Typography variant="body1" color="textSecondary" align="center">
											No hay usuarios disponibles
										</Typography>
									</Grid>
								)}
							</Grid>
						</Grid>

						{/* ============================================
						   SEPARADOR (solo si hay dispositivos)
						   ============================================ */}
						{dispositivos.length > 0 && (
							<Grid item xs={11}>
								<Divider variant="middle" sx={{ minWidth: '100%' }} />
							</Grid>
						)}

						{/* ============================================
						   CONTENEDOR DE DISPOSITIVOS (ROL TOTEM)
						   ============================================ */}
						{dispositivos.length > 0 && (
							<Grid container xs={11}>
								<Grid
									container
									direction="column"
									justifyContent="start"
									alignItems="start"
									xs={12}
								>
									<Typography variant="h4" gutterBottom>
										<DevicesIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
										Dispositivos: {dispositivos.length}
									</Typography>
								</Grid>

								<Grid item xs={12} sx={{ mb: 2 }}>
									<TextField
										id="buscar-dispositivo"
										label="Buscar dispositivo..."
										variant="standard"
										size="small"
										name='search'
										fullWidth
										onChange={buscarDispositivo}
									/>
								</Grid>

								<Grid
									container
									direction="row"
									justifyContent="center"
									alignItems="center"
									xs={12}
									gap={2}
								>
									{dispositivos.map((dispositivo) => (
										<Grid item xs={12} sm={12} md={10} lg={5.5} xl={1.7} key={dispositivo.id}>
											<UsuarioCard
												usuario={dispositivo}
												// opciones={opcionesUsuario}
												cargarUsuarios={cargarUsuarios}
												roles={roles}
												departamentos={departamentos}
												tipo="dispositivo"
											/>
										</Grid>
									))}
								</Grid>
							</Grid>
						)}

						{/* ============================================
						   SECCIÓN DE CLIENTES (COMENTADA TEMPORALMENTE)
						   ============================================ */}
						{/* 
						<Grid item xs={11}>
							<Divider variant="middle" sx={{ minWidth: '100%' }} />
						</Grid>

						{usuariosClientes.length > 0 && (
							<Grid container xs={11}>
								<Grid
									container
									direction="column"
									justifyContent="start"
									alignItems="start"
									xs={12}
								>
									<Typography variant="h4" gutterBottom>Clientes: {usuariosClientesAgrupados.length}</Typography>
								</Grid>

								<Grid item xs={12} sx={{ mb: 2 }}>
									<TextField id="standard-basic" label="Buscar empresa..." variant="standard" size="small" name='search' fullWidth onChange={buscarEmpresa} />
								</Grid>
								
								<Grid
									container
									direction="row"
									justifyContent="center"
									alignItems="center"
									xs={12}
									gap={2}
								>
									{usuariosClientesAgrupados.map((cliente, index) => (
										<React.Fragment key={cliente.cliente_id}>
											<Grid
												container
												direction="column"
												justifyContent="start"
												alignItems="start"
												xs={11.5} sm={12} md={12} lg={5.5} xl={2.5}
												gap={2}
												className="empresa-card fade-in2"
												sx={{ padding: 2, borderRadius: 3, boxShadow: 3, background: "var(--fondoTarjeta)", minHeight: '15vh' }}
											>
												<Grid item xs={12} onClick={() => setOpenCliente(cliente.cliente_id)}>
													<Typography variant="h5" sx={{ p: 1, fontSize: 25, textAlign: 'left' }}>
														<Badge
															badgeContent={cliente.usuarios_clientes.length}
															color="primary"
															anchorOrigin={{
																vertical: 'bottom',
																horizontal: 'left',
															}}
														>
															<ApartmentIcon sx={{ mr: 1, mt: -1.3, fontSize: 50 }} />
														</Badge>
														{cliente.nombre_cliente}
													</Typography>
												</Grid>

												<Divider variant="middle" sx={{ minWidth: '90%' }} />

												<FormControlLabel
													control={
														<Switch
															size="small"
															checked={cliente.acceso_tienda == 1 ? true : false}
															onChange={(event) => accesoTienda(event, cliente.cliente_id)} />
													}
													label="Acceso a Tienda"
												/>
											</Grid>

											<Dialog
												fullWidth
												maxWidth="xl"
												open={openCliente === cliente.cliente_id}
												onClose={handleClose}
											>
												<DialogContent className='App' style={{ minHeight: '80vh' }}>
													<Grid
														container
														direction="row"
														justifyContent="space-between"
														alignItems="center"
														xs={12}
													>
														<Typography variant="h4">{cliente.nombre_cliente}</Typography>

														<Grid
															container
															direction="row"
															justifyContent="center"
															alignItems="center"
															xs={'auto'}
														>
															<FormControlLabel
																control={
																	<Switch
																		size="small"
																		checked={cliente.acceso_tienda == 1 ? true : false}
																		onChange={(event) => accesoTienda(event, cliente.cliente_id)} />
																}
																label="Acceso a Tienda"
															/>

															<CancelIcon fontSize='medium' className='pointer' onClick={handleClose} />
														</Grid>
													</Grid>

													<Divider sx={{ mt: 1, mb: 3 }}></Divider>
													<Grid
														container
														direction="row"
														justifyContent="center"
														alignItems="center"
														xs={12}
														gap={2}
													>
														{cliente.usuarios_clientes.map((info, index) => (
															<Grid item xs={11.5} md={2.5} key={info.id}>
																<UsuarioCard usuario={info} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
															</Grid>
														))}
													</Grid>
												</DialogContent>
											</Dialog>
										</React.Fragment>
									))}
								</Grid>
							</Grid>
						)}
						*/}

					</Grid>

					{/* Formulario de creación de usuario */}
					{openCrearUsuario && (
						<FormCrearUsuario
							open={openCrearUsuario}
							setOpen={setOpenCrearUsuario}
							cargarUsuarios={cargarUsuarios}
							departamentos={departamentos}
							roles={roles}
							clientes={clientes}
							tipo="usuario"
						/>
					)}


					{/* ============================================
						   APARTADO PARA QUE EL CLIENTE CREE DISPOSITIVOS (EN PRINCIPIO LOS DAREMOS DE ALTA DESDE BBDD))
						============================================ */}

					{/* {openCrearDispositivo && (
						<FormCrearUsuario
							open={openCrearDispositivo}
							setOpen={setOpenCrearDispositivo}
							cargarUsuarios={cargarUsuarios}
							departamentos={departamentos}
							roles={roles}
							clientes={clientes}
							tipo="dispositivo"
						/>
					)} */}
				</>
			)}
		</div>
	);
};